// extracted by mini-css-extract-plugin
export default {"container":"profile_container__Ja2Xu","wrapper":"profile_wrapper__Bjbhh","main":"profile_main__teJi9"};